import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import eventImage from '../assets/img/event/02.jpg'
import instituteImage from '../assets/img/institute/1.jpg'
import instituteImage1 from '../assets/img/event/02.jpg';
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';


const institutesData = [
  {
    image: {eventImage},
    lessons: '10 Lessons',
    rating: 4,
    reviews: '(4.0)',
    ranking: '#1 out of 50 in India 2024',
  },
  {
    image: {instituteImage},
    lessons: '10 Lessons',
    rating: 4,
    reviews: '(4.0)',
    ranking: '#1 out of 50 in India 2024',
  },
  {
    image: {instituteImage},
    lessons: '10 Lessons',
    rating: 4,
    reviews: '(4.0)',
    ranking: '#1 out of 50 in India 2024',
  },
  {
    image: {eventImage},
    lessons: '10 Lessons',
    rating: 4,
    reviews: '(4.0)',
    ranking: '#1 out of 50 in India 2024',
  },
];

const carouselOptions = {
  loop: true,
  margin: 20,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  dots: false,
  nav: false,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    1000: { items: 3 },
  },
};

const InstitutesSection = () => {
  const [personalInfo, setPersonalInfo] = useState([]);
  const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state
  const fetchInstitute = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getInstitutesData`);
        setPersonalInfo(response.data.data.personalInfo);
        setProfileImg(response.data.data.profileImg);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchInstitute();
    }, []); 
  
  return (
    <div className="event-area py-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="site-heading text-left">
              <h2 className="site-title">Institute's'</h2>
            </div>
          </div>
        </div>

        <OwlCarousel className="event-slider owl-theme" {...carouselOptions}>
          {profileImg.map((item, index) => (
            // <Link className="theme-btn" to={`/InstituteDetail/${item.id}`}>
                                    
                                
            <div className="event-item" key={index}>
              <div className="event-img">
                <img src={`${Image_Base_Url}${item.profile_image_path}`} alt="Profile" onError={(e) => e.target.src = bannerIcon1 } />
                {/* <img src={item.image} alt={`Institute ${index}`} /> */}
              </div>
              <div className="course-meta">
                <span className="course-meta-left">
                  <i className="far fa-book"></i> {item.lessons}
                </span>
                <div className="course-rating">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={
                        i < item.rating ? 'fas fa-star' : 'far fa-star'
                      }
                    ></i>
                  ))}
                  <span>{item.reviews}</span>
                </div>
              </div>
              <div className="event-info dvder">
                <p>
                  <strong>Ranking</strong> - {item.ranking}
                </p>
              </div>
            </div>
            // </Link>
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};

export default InstitutesSection;
